/* eslint-disable-next-line */
import http from './index';

/**
 * 单个题组练习题列表[学生]
 * @param {string} bundleId 题组ID
 * @param {string} classId 班级ID
 */
export function getSubject(params) {
  return http({
    url: '/subject/s-practices',
    method: 'GET',
    params,
  });
}

/**
 * 获取题组及其下各习题作答状态[学生]
 * @param {string} bundleId 题组ID
 * @param {string} classId 班级ID
 */
export function getBundleStatus(params) {
  return http({
    url: '/core/bundle/status',
    method: 'GET',
    params,
  });
}



/**
 * 保存或更新学员选择题答案
 * @param {integer} questionId 选择题题目ID
 */
export function updateStudentAnswer(params) {
  return http({
    url: '/choice/answer',
    method: 'POST',
    data: params,
  });
}

/**
 * 学员获得选择题作业
 * @param {integer} questionId 选择题题目ID
 */
export function getStudentAnswer(params) {
  return http({
    url: '/choice/answer/studentGet',
    method: 'GET',
    params,
  });
}

/**
 * 获取题目答题结果[学生]
 * @param {integer} category 题目题类型
 * @param {string} classId 班级ID
 * @param {string} lessonId 讲次ID
 * @param {integer} projectId 题目题ID
 */
export function updateBundle(params) {
  return http({
    url: '/subject/s-practices/solution',
    method: 'GET',
    params,
  });
}

/**
 * 学生端获取竞赛题组是否收题
 * @param {string} bundleId 题组ID
 */
export function getCompetitionStatus(params) {
  return http({
    url: `/competition/end/${params.bundleId}/${params.timingType}`,
    method: 'GET',
    params,
  });
}


/**
 * 获取猴博士题目描述和默认提示的接口
 * @param {string} practiceId 习题Id
 * @param {Number} category 习题类型
 */
export function getHbs(params) {
  return http({
    url: '/doctor/tip',
    method: 'GET',
    params,
  });
}


/**
 * 记录学生第一次打开题组的时间
 * @param {string} bundleId 习题Id
 */
export function getStuFirstTime(params) {
  return http({
    url: `/sse/competition/firstOpen/${params.bundleId}`,
    method: 'put',
  });
}
/**
 * 学生获取自己Paper答案
 * @param {string} classId 班级ID
 * @param {string} lessonId 讲次ID
 * @param {string} questionId paper习题ID
 */
export function stdGetPaperAnswer(params) {
  return http({
    url: '/paper/answer/studentGet',
    method: 'GET',
    params,
  });
}
/**
 * 保存Paper答案
 * @param {string} answer 答案
 * @param {string} classId 班级ID
 * @param {string} lessonId 讲次ID
 * @param {string} questionId DIY习题对应的项目ID
 * @param {string} result 答题结果：1-正确，2-错误，3-已订正
 */
export function updatePaperAnswer(params) {
  return http({
    url: '/paper/answer',
    method: 'POST',
    data: params,
  });
}
/**
 * 同意赛前阅读
 * @param {
   string
 }
 bundleId 题组id
 * @param {
   string
 }
 competitionId 竞赛id
 */
export function readCompetition(params) {
   return http({
     url: '/protocol/read',
     method: 'post',
     data: params,
   });
}
export function saveProject(params) {
  return http({
    url: `/subject/bundle/submit/${params.bundleId}`,
    method: 'get'
  });
}
/**
 * 查看当前题组是否发题状态
 bundleId 题组id
 * @param {
   string
 }
 **/
export function getQuestionGroupState(params) {
  return http({
    url: `/subject/bundle/status/${params.bundleId}`,
    method: 'GET',
    params,
  });
}

/**
 * 记录交卷时间
**/
export function recordSubmitTime({ competitionId, bundleId, type }) {
  return http({
    url: `/subject/bundle/record/submitTime/${competitionId}/${bundleId}`,
    method: 'put',
    params: { type }
  });
}

/**
 * 记录开始考试时间
**/
export function recordStartAnswerTime({ competitionId, bundleId }) {
  return http({
    url: `/subject/bundle/record/startAnswerTime/${competitionId}/${bundleId}`,
    method: 'put'
  });
}




